import React from "react";


import parseHTML from 'html-react-parser';


import { Col, Row } from "react-bootstrap";


import { CardComponent ,CardRoundIconOrNumberComponent } from "@Components/Elements";


import "./index.scss";


type ElementDecorationDataType = {
    type?: "text" | "svg";
    value?: string;
    size?: "auto";
    noBg?: boolean;
}


type ExplanationListElementComponentProps = {
    elementTitle: string;
    elementContent: string;
    elementOrderNr?: number;
    elementIcon?:string;
    className?: string;
    xs?: number; xl?: number;
}


export const ExplanationListElementComponent:React.FC<ExplanationListElementComponentProps> = ({
    elementTitle, elementContent, elementOrderNr, elementIcon, className,
    xs = 12, xl
}) => {

    const elementDecorationData:ElementDecorationDataType = {};

    if (elementOrderNr) {
        elementDecorationData.type = "text";
        elementDecorationData.value = elementOrderNr.toString();
    }

    if (elementIcon) {
        elementDecorationData.type = "svg";
        elementDecorationData.value = elementIcon;
        elementDecorationData.size = "auto";
        elementDecorationData.noBg = true;
    }

    return (
        <CardComponent
            type={1}
            className={`explanation-list-element` + (className ? ` ${className}` : '')}
            xs={xs} xl={xl ?? xs}
        >

            <Col xs={2} xl={1} className={`explanation-list-element__element-order-nr` + (className ? ` ${className}__element-order-nr` : '')}>
                {elementDecorationData.value && <CardRoundIconOrNumberComponent
                    type={elementDecorationData.type}
                    content={elementDecorationData.value}
                    size={elementDecorationData.size}
                    noBackground={elementDecorationData.noBg}
                    className={`explanation-list-element__element-order-nr__value` + (className ? ` ${className}__element-order-nr__value` : '')}
                />}
            </Col>

            <Col xs={10} xl={11} className={`explanation-list-element__element-content` + (className ? ` ${className}__element-content` : '')}>
                <Row className={`explanation-list-element__element-content__content` + (className ? ` ${className}__element-content__content` : '')}>
                    <Col xs={12} className={`explanation-list-element__element-content__title` + (className ? ` ${className}__element-content__title` : '')}>
                        <span>{elementTitle}</span>
                    </Col>
                    <Col xs={12} className={`explanation-list-element__element-content__text` + (className ? ` ${className}__element-content__text` : '')}>
                        {parseHTML(elementContent)}
                    </Col>
                </Row>
            </Col>

        </CardComponent>
    );

};


export default ExplanationListElementComponent;
